<div class="head">
  <atm-filters
    [availableFilters]="config.filters"
    [filtersSetted]="filtersSetted"
  ></atm-filters>
</div>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<section>
  <ng-container *ngIf="!isLoading">
    <div
      class="list"
      *ngFor="let data of ressources"
      (click)="select(data)"
      [class.selected]="data.id === selectedRessource?.id"
    >
      <span
        *ngFor="let display of config.display"
        [ngClass]="display.class || 'main'"
      >
        {{ data | displayData : display.path : display }}
      </span>
    </div>
  </ng-container>
</section>
<mat-paginator [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons>
</mat-paginator>
